import {
  CLEAR,
  UPDATE_COMMENT,
  UPDATE_ACTIVE,
  UPDATE_TYPE,
  UPDATE_DIALOG_TYPE,
  APPROVAL_TYPE,
  SET_DIALOG_ACTIVE,
  SET_DIALOG_INACTIVE,
  UPDATE_WORKFLOW_ID,
  UPDATE_PROJECT_ID,
  UPDATE_SKIPABLES,
  SUBMIT,
  SUBMIT_START,
} from './constants'

const clear = () => ({ type: CLEAR })
const updateComment = (comment) => ({ type: UPDATE_COMMENT, comment })
const updateActive = (active) => ({ type: UPDATE_ACTIVE, active })
const updateDialogType = (value) => ({ type: UPDATE_DIALOG_TYPE, value })
const updateType = (value) => ({ type: UPDATE_TYPE, value })
const updateWorkflowId = (id) => ({ type: UPDATE_WORKFLOW_ID, id })
const updateProjectId = (id) => ({ type: UPDATE_PROJECT_ID, id })
const updateSkipables = (skipables) => ({ type: UPDATE_SKIPABLES, skipables })
const setDialogActive = (value) => ({ type: SET_DIALOG_ACTIVE, value })
const setDialogInactive = () => ({ type: SET_DIALOG_INACTIVE })
const submit = () => ({ type: SUBMIT })
const submitStart = (workflowId, projectId, value) => ({ type: SUBMIT_START, workflowId, projectId, value })
const acceptStart = (workflowId, projectId) => submitStart(workflowId, projectId, APPROVAL_TYPE.APPROVE)
const rejectStart = (workflowId, projectId) => submitStart(workflowId, projectId, APPROVAL_TYPE.REJECT)
const resetActive = () => updateActive(false)

export {
  clear,
  submit,
  updateComment,
  updateActive,
  updateType,
  updateDialogType,
  setDialogActive,
  setDialogInactive,
  updateWorkflowId,
  updateProjectId,
  updateSkipables,
  acceptStart,
  rejectStart,
  resetActive,
}
